import React, { useState } from 'react';
import { Modal } from '../ui/Modal';
import { Input } from '../ui/Input';
import { Button } from '../ui/Button';
interface CheckInModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (checkin: any) => void;
}
export function CheckInModal({
  isOpen,
  onClose,
  onSave
}: CheckInModalProps) {
  const [formData, setFormData] = useState({
    mood: '',
    symptoms: '',
    emotionalImpact: '',
    notes: ''
  });
  const moods = [{
    label: 'Great',
    emoji: '😊'
  }, {
    label: 'Good',
    emoji: '🙂'
  }, {
    label: 'Okay',
    emoji: '😐'
  }, {
    label: 'Bad',
    emoji: '😔'
  }, {
    label: 'Terrible',
    emoji: '😢'
  }];
  const handleSubmit = () => {
    if (!formData.mood) return;
    onSave(formData);
    onClose();
    setFormData({
      mood: '',
      symptoms: '',
      emotionalImpact: '',
      notes: ''
    });
  };
  return <Modal isOpen={isOpen} onClose={onClose} title="Health & Impact Check-in" footer={<div className="flex justify-end space-x-3" data-id="element-7">
          <Button variant="ghost" onClick={onClose} data-id="element-8">
            Cancel
          </Button>
          <Button onClick={handleSubmit} disabled={!formData.mood} data-id="element-9">
            Save Check-in
          </Button>
        </div>} data-id="element-6">
      <div className="space-y-6" data-id="element-10">
        <div data-id="element-11">
          <label className="block text-sm font-medium text-text-primary mb-3" data-id="element-12">
            How are you feeling today?
          </label>
          <div className="flex justify-between gap-2" data-id="element-13">
            {moods.map(m => <button key={m.label} onClick={() => setFormData({
            ...formData,
            mood: m.label
          })} className={`
                  flex flex-col items-center p-3 rounded-xl transition-all w-full
                  ${formData.mood === m.label ? 'bg-primary-purple text-white transform scale-105 shadow-md' : 'bg-gray-50 text-gray-600 hover:bg-gray-100'}
                `} data-id="element-14">
                <span className="text-3xl mb-1" data-id="element-15">{m.emoji}</span>
                <span className="text-xs font-medium" data-id="element-16">{m.label}</span>
              </button>)}
          </div>
        </div>

        <Input multiline label="Physical Symptoms" placeholder="Headaches, insomnia, fatigue, etc..." value={formData.symptoms} onChange={e => setFormData({
        ...formData,
        symptoms: e.target.value
      })} data-id="element-17" />

        <Input multiline label="Emotional Impact" placeholder="Anxiety, fear, depression, stress..." value={formData.emotionalImpact} onChange={e => setFormData({
        ...formData,
        emotionalImpact: e.target.value
      })} data-id="element-18" />

        <Input multiline label="Additional Notes" placeholder="Any other thoughts or observations..." value={formData.notes} onChange={e => setFormData({
        ...formData,
        notes: e.target.value
      })} data-id="element-19" />
      </div>
    </Modal>;
}